window.onload = function () {

    window.spWhatsAppTrack = function(buttonType){
       if(buttonType == 'widgetButton'){
            if (typeof gtag == 'function') {
                gtag('event', 'adw_whatsapp_chat');
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'telefono', 'click', 'whatsapp');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'whatsapp' });
            };
           console.log('click in whatsapp');
         
       }
    };
  
    // jQuery is not loaded
    console.info("loading custom scripts for events");
    
    /**
     * Activacion e incrustación de clases para eventos
     */
    document.querySelectorAll('a[href^="tel"]').forEach(element => {
        element.classList.add("link-phone");
        element.addEventListener('click', function () {
            if (typeof gtag == 'function') {
                gtag('event', 'adw_click_telefono');
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'telefono', 'click', 'llamada');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'telefono' });
            };
        })
    });
    document.querySelectorAll('a[href^="mailto"]').forEach(element => {
        element.classList.add("link-email");
        element.setAttribute("target", "_blank");
        element.addEventListener('click', function () {
            if (typeof gtag == 'function') {
                gtag('event', 'adw_click_email');
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'email', 'click', 'envio');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'email' });
            };
        });
    });
    document.querySelectorAll('a[href*="wa.me"]').forEach(element => {
        element.classList.add("link-whatsapp");
        element.setAttribute("target", "_blank");
        element.addEventListener('click', function () {
            if (typeof gtag == 'function') {
                gtag('event', 'adw_click_whatsapp');
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'whatsapp', 'click', 'envio');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'whatsapp' });
            };
        });
    });
    document.querySelectorAll('a[href*="api.whatsapp"]').forEach(element => {
        element.classList.add("link-whatsapp");
        element.setAttribute("target", "_blank");
        element.addEventListener('click', function () {
            if (typeof gtag == 'function') {
                gtag('event', 'adw_click_whatsapp');
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'whatsapp', 'click', 'envio');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'whatsapp' });
            };
        });
    });        
    document.querySelectorAll('a[href*="m.me"]').forEach(element => {
        element.classList.add("link-messenger");
        element.setAttribute("target", "_blank");
        element.addEventListener('click', function () {
            if (typeof gtag == 'function') {
                gtag('event', 'adw_click_messenger');
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'messenger', 'click', 'envio');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'messenger' });
            };
        });
    });
    document.querySelectorAll('a[href*="maps"]').forEach(element => {
        element.classList.add("link-map");
        element.setAttribute("target", "_blank");
        element.addEventListener('click', function () {
            if (typeof gtag == 'function') {
                gtag('event', 'adw_click_mapa');
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'maps', 'click', 'envio');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'maps' });
            };
        });
    });
  
  }